/** WeatherAPI.com publishes hourly precipitation map tiles in UTC. This is a forecast, not radar. */
export function precipitationForecastTileUrl(selected: Date, now: Date): string | null {
  const selectedMs = selected.getTime();
  const nowMs = now.getTime();
  if (!Number.isFinite(selectedMs) || !Number.isFinite(nowMs)) return null;
  if (selectedMs < nowMs - 60 * 60_000 || selectedMs > nowMs + 24 * 60 * 60_000) return null;

  const hour = new Date(Math.floor(Math.max(selectedMs, nowMs) / 3_600_000) * 3_600_000);
  const date = `${hour.getUTCFullYear()}${String(hour.getUTCMonth() + 1).padStart(2, '0')}${String(hour.getUTCDate()).padStart(2, '0')}`;
  const utcHour = String(hour.getUTCHours()).padStart(2, '0');
  return `https://weathermaps.weatherapi.com/precip/tiles/${date}${utcHour}/{z}/{x}/{y}.png`;
}
